import { render, staticRenderFns } from "./MFormPassword.vue?vue&type=template&id=79f9bee7&"
import script from "./MFormPassword.vue?vue&type=script&lang=js&"
export * from "./MFormPassword.vue?vue&type=script&lang=js&"
import style0 from "./MFormPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports